var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 48,
    fill: "#2C2929"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_227_5230",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 56,
    height: 56
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 56,
    height: 56,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_227_5230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.6667 45.6667V38.6667H52.6667V34H59.6667V27H64.3333V34H71.3333V38.6667H64.3333V45.6667H59.6667ZM38.6667 69C35.4389 69 32.6875 67.8625 30.4125 65.5875C28.1375 63.3125 27 60.5611 27 57.3333C27 55.4667 27.4083 53.7264 28.225 52.1125C29.0417 50.4986 30.1889 49.1278 31.6667 48V34C31.6667 32.0556 32.3472 30.4028 33.7083 29.0417C35.0694 27.6806 36.7222 27 38.6667 27C40.6111 27 42.2639 27.6806 43.625 29.0417C44.9861 30.4028 45.6667 32.0556 45.6667 34V48C47.1444 49.1278 48.2917 50.4986 49.1083 52.1125C49.925 53.7264 50.3333 55.4667 50.3333 57.3333C50.3333 60.5611 49.1958 63.3125 46.9208 65.5875C44.6458 67.8625 41.8944 69 38.6667 69ZM36.3333 43.3333H41V34C41 33.3389 40.7764 32.7847 40.3292 32.3375C39.8819 31.8903 39.3278 31.6667 38.6667 31.6667C38.0056 31.6667 37.4514 31.8903 37.0042 32.3375C36.5569 32.7847 36.3333 33.3389 36.3333 34V43.3333Z",
    fill: "#FF9B32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarm);
export default __webpack_public_path__ + "static/media/warm.205918bbd53adcda32c3a490ce07500e.svg";
export { ForwardRef as ReactComponent };